/**
 * Safe helpers for browser print/PDF preview windows.
 * Prefer Blob URLs over document.write() so we never open an HTML-injection sink.
 */

export function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Open a print-ready HTML document without document.write / innerHTML.
 * @param {string} html Fully-formed HTML document (dynamic values must already be escaped).
 * @returns {Window|null} The opened window, or null if popups are blocked.
 */
export function openPrintHtml(html) {
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const printWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (!printWindow) {
    URL.revokeObjectURL(url);
    return null;
  }

  const revoke = () => {
    try {
      URL.revokeObjectURL(url);
    } catch (_) {
      // ignore
    }
  };

  // Revoke after the document has a chance to load; also cover early close.
  const timer = window.setTimeout(revoke, 60_000);
  try {
    printWindow.addEventListener('load', () => {
      window.clearTimeout(timer);
      // Keep the blob alive briefly so print dialog can still read the doc.
      window.setTimeout(revoke, 2_000);
    });
  } catch (_) {
    window.clearTimeout(timer);
    window.setTimeout(revoke, 2_000);
  }

  return printWindow;
}
